// import { jwtDecode } from 'jwt-decode';

import { IdToken } from '@auth0/auth0-react';
import {
  // DEFAULT_ADMIN_PORT,
  // USER_ACCESS_KEY,
  USER_REFRESH_KEY,
} from 'constants/general';
import { TENANT_TYPE } from 'types/general.types';
import { User } from 'types/user.types';
import { getCookieValue } from 'utils/storage';

export const getUserFromCookie = (accessToken: string, idToken: IdToken): User | null => {
  const refreshToken = getCookieValue(USER_REFRESH_KEY);
  if (!accessToken) {
    return null;
  }

  // const userData = jwtDecode<TokenDecoded>(accessToken);
  // const isAdminUser = checkIsAdminUser(userData);

  // if (isAdminUser) {
  //   redirectToAdmin();
  //   return null;
  // }

  return {
    username: 'demo',
    tenantKey: 'demo',
    accessToken: accessToken,
    idToken: idToken,
    refreshToken: refreshToken ?? '',
  };
};

export const getTenantFromCookie = (): TENANT_TYPE => TENANT_TYPE.DUCKENERGY;
// COMMENTED by Vlad.k - disbled auth
/*
{
  const token = getCookieValue(USER_ACCESS_KEY);
  if (!token) {
    return TENANT_TYPE.DUCKENERGY;
  }
  const userData = jwtDecode<TokenDecoded>(token);

  const tenant = userData['cognito:groups'][0].split(':')[1] as TENANT_TYPE;

  if (Object.values(TENANT_TYPE).includes(tenant)) {
    return tenant;
  }

  return TENANT_TYPE.DUCKENERGY
}
  */

// const checkIsAdminUser = (userData: TokenDecoded) => {
//   const groups = userData['cognito:groups'] || [];
//   const isAdminUser = groups.some(group => group.includes('admin'));

//   return isAdminUser;
// };

// const redirectToAdmin = () => {
//   const currentUrl = new URL(window.location.href);

//   if (currentUrl.hostname === 'localhost') {
//     // For development environment
//     currentUrl.port = DEFAULT_ADMIN_PORT; // admin should run on the port 3001
//     currentUrl.pathname = '';
//   } else {
//     // For production environment
//     currentUrl.hostname = `admin.${currentUrl.hostname.split('.').slice(1).join('.')}`;
//   }

//   window.location.href = currentUrl.toString();
//   return null;
// };
